exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".demo-section[data-v-f545e4d8]{margin:2rem 0;padding:1rem;background-color:#f8f9fa;border-left:4px solid #007bff;border-radius:.25rem}.demo-section h3[data-v-f545e4d8]{color:#007bff;margin-bottom:.5rem}.example-section[data-v-f545e4d8]{margin-bottom:2rem;padding:1rem;border:1px solid #ddd;border-radius:.25rem}.example-section h4[data-v-f545e4d8]{color:#007bff;margin-bottom:1rem}.new-invoice[data-v-f545e4d8]{border-left:4px solid #28a745;background-color:#f8fff9}.new-invoice h4[data-v-f545e4d8]{color:#28a745}.existing-invoice[data-v-f545e4d8]{border-left:4px solid #ffc107;background-color:#fffdf5}.existing-invoice h4[data-v-f545e4d8]{color:#e0a800}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f545e4d8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/InvoiceManagementExample.vue
// module id = 1845
// module chunks = 0